import { Box } from '@mui/material';

interface NumberedStepProps {
  number: number;
}

export function NumberedStep({ number }: NumberedStepProps) {
  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'scale(1.1)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        },
      }}
    >
      {number}
    </Box>
  );
}
